import { render, staticRenderFns } from "./reviewPaperConfig.vue?vue&type=template&id=78fa21c4&scoped=true"
import script from "./reviewPaperConfig.vue?vue&type=script&lang=js"
export * from "./reviewPaperConfig.vue?vue&type=script&lang=js"
import style0 from "./reviewPaperConfig.vue?vue&type=style&index=0&id=78fa21c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa21c4",
  null
  
)

export default component.exports